export default __webpack_public_path__ + "static/media/pdf-icon.ba4a9de7.svg";